import {debounce} from 'debounce';

export default {

  methods: {
    getUsersListDebounce: debounce(function (type = null, search, loading) {
      /*if (!search || search && search.length < 2) {
          return;
      }*/
      this.getUsersList(search, loading, type);
    }, 500),

    getUsersList(search, loading, type) {

      let searchUrl = '';
      if (search) {
        searchUrl = '&searchFields=id:like&search=' + search;
      }
      if (type === 'agencyUserList') {
        searchUrl += '&type=agencyUserList';
      }

      let url = '';
      if (this.$auth.hasRole('admin')) {
        url = '/users?orderBy=id&sortedBy=desc&perPage=50';
      } else {
        url = '/agency-users?orderBy=id&sortedBy=desc&perPage=50';
      }

      this.$axios.get(url + searchUrl)
        .then(response => {

          let fieldValue = 'value';
          let fieldText = 'text';
          if (type === 'pretarget' || type === 'agencyUserList') {
            fieldValue = 'code';
            fieldText = 'label';
          }

          this.users = response.data.data.map(item => ({
            [fieldValue]: item.id,
            [fieldText]: `ID: ${item.id} | ${item.firstName} ${item.lastName} | ${item.email}`,
            agencyMarkup: item.agencyMarkup
          }));

          // Include current user for agency role in pretarget context
          if (this.$auth.hasRole('agency') && type === 'pretarget') {
            const currentUser = this.$auth.user();
            if (currentUser && currentUser.id) {
              const exists = this.users.some(u => u[fieldValue] === currentUser.id);
              if (!exists) {
                const currentUserOption = {
                  [fieldValue]: currentUser.id,
                  [fieldText]: `ID: ${currentUser.id} | ${currentUser.firstName} ${currentUser.lastName} | ${currentUser.email}`,
                  agencyMarkup: currentUser.agencyMarkup
                };
                this.users.unshift(currentUserOption);
              }
            }
          }

          if (loading) {
            loading(false);
          }
        })
        .catch(() => {
          this.users = [];

          if (loading) {
            loading(false);
          }
        });
    },
  },
};
